















































































































import { Vue, Component } from 'vue-property-decorator';

import logo from '@/components/atomic/organisms/Logo.vue';
import buttonGreen from '@/components/atomic/atoms/ButtonGreen.vue';

@Component({
  name: 'Header',
  components: {
    logo,
    buttonGreen
  },
})
/**
 * @vuese
 * @group Atomic/Organisms
 * header for when user don't login
 */
export default class Header extends Vue {
  // [data]
  mobMenuIsOpen: boolean = false;

  // [method]
  getStartedNow() {}

  toggleMobMenu() {
    this.mobMenuIsOpen = !this.mobMenuIsOpen;
    document.body.style.overflowX = 'hidden';
    if (this.mobMenuIsOpen) {
      document.body.style.overflowY = 'hidden';
      return;
    }
    document.body.style.overflowY = 'auto';
  }

  clickAction() {
    if (this.mobMenuIsOpen) {
      this.mobMenuIsOpen = false;
      document.body.style.overflowY = 'auto';
    }
  }
}
